<template>
  <div>
    <md-field>
      <label>Projektbezeichnung</label>
      <md-input v-model="project"></md-input>
    </md-field>

    <md-field>
      <label>Passwortschutz (optional)</label>
      <md-input v-model="password"></md-input>
    </md-field>

    <md-field>
      <label>Upload-Ziel</label>
      <md-input v-model="uploadTarget"></md-input>
    </md-field>

    <md-switch v-model="video" class="md-primary"
      >{{ !video ? "keine Video" : "Video-" }} Aufnahme</md-switch
    >
    <md-switch v-model="audio" class="md-primary"
      >{{ !audio ? "keine Audio-" : "Audio-" }} Aufnahme</md-switch
    >
    <md-switch v-model="screencast" class="md-primary"
      >{{ !screencast ? "keine Screen-" : "Screen-" }} Aufnahme</md-switch
    >

    <div :key="code" v-if="code">
      <h2>Individueller Link zum Online-Recorder</h2>
      <div>
        <md-field>
          <label>URL</label>
          <md-textarea
            id="code"
            onclick="this.focus();this.select()"
            v-model="code"
            readonly
          >
          </md-textarea>
        </md-field>
      </div>
      <div>
        <md-button
          v-if="code"
          class="md-raised md-primary"
          :href="code"
          :target="'_blank'"
        >
          <md-icon>link</md-icon> Ansehen
        </md-button>

        <md-button
          v-if="code"
          class="md-raised md-primary"
          id="codeButton"
          @click.stop.prevent="copyCode"
        >
          <span v-if="!copyCodeBtn"><md-icon>file_copy</md-icon> In Zwischenablage kopieren</span>
          <span v-else><md-icon>check</md-icon> Erfolgreich kopiert</span>
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      project: "",
      password: "",
      video: false,
      audio: false,
      screencast: false,
      code: "",
      copyCodeBtn: false,
      uploadTarget: 'https://recorder.vorbild-schule.de/assets/upload.php'
    };
  },
  watch: {
    video() {
      this.getCode();
    },
    uploadTarget() {
      this.getCode();
    },
    audio() {
      this.getCode();
    },
    screencast() {
      this.getCode();
    },
    project() {
      this.getCode();
    },
    password() {
      this.getCode();
    }
  },
  methods: {
    copyCode() {
      let testingCodeToCopy = document.getElementById("code");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
      } catch (err) {
        window.console.log(err);
      }

      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();

      this.copyCodeBtn = true;

      setTimeout(function () {
        this.copyCodeBtn = false;
      }.bind(this), 3000)
    },
    getCode() {
      var code = {
        project: this.project,
        password: this.password,
        video: this.video,
        audio: this.audio,
        screencast: this.screencast,
        uploadTarget: this.uploadTarget
      };
      var url =
        "https://recorder.vorbild-schule.de/p/" +
        btoa(JSON.stringify(code)) +
        "/record.html";

      this.code =
        "<b>" + this.project + '</b>: <a href="' + url + '">' + url + "</a>";
      this.code = url;
      if (
        code.video === false &&
        code.audio === false &&
        code.screencast === false
      ) {
        this.code = "";
      }
      if (!this.project || this.project.trim() === "") {
        this.code = "";
      }
    }
  },
  mounted() {},
  computed: {}
};
</script>
<style lang="sass" scoped></style>
